// Formata valor monetário em pt-BR sem o "-0,00" que aparece quando um
// resultado deveria ser zero mas chega como -0 ou como um resíduo de ponto
// flutuante negativo (ex: -0.0000000001 de somas encadeadas) — arredonda pra
// 2 casas antes de decidir o sinal, então nunca imprime negativo pra um
// valor que é efetivamente zero.
export const formatarMoeda = (valor: number): string => {
  const arredondado = Math.round((valor + Number.EPSILON) * 100) / 100;
  const semZeroNegativo = arredondado === 0 ? 0 : arredondado;
  return semZeroNegativo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
